import { CompanyStatus } from '../../../common/constants';
import { CompanyVerificationInfo } from '../../../common/interfaces/entities';

export const COMPANY_VERIFICATION_POLLING_TIMEOUT_IN_MS = 1000 * 30;

export const CompanyVerificationPollingMode = {
  ID_LEGAL_DOCUMENT: 'ID_LEGAL_DOCUMENT',
  SG_ACRA_BIZFILE: 'SG_ACRA_BIZFILE',
} as const;

export type CompanyVerificationPollingMode =
  (typeof CompanyVerificationPollingMode)[keyof typeof CompanyVerificationPollingMode];

export type CompanyVerificationPollingResult = {
  status: CompanyStatus;
  verificationInfo: CompanyVerificationInfo;
};

export function shouldResolveCompanyVerificationPolling({
  mode,
  status,
  verificationInfo,
}: CompanyVerificationPollingResult & {
  mode: CompanyVerificationPollingMode;
}) {
  const document = verificationInfo?.lastVerificationRequest?.document;

  if (mode === CompanyVerificationPollingMode.SG_ACRA_BIZFILE) {
    return [
      CompanyStatus.VERIFIED,
      CompanyStatus.REJECTED,
      CompanyStatus.BLOCKED,
    ].includes(status);
  }

  return Boolean(
    document &&
      'companyNpwpDocumentMetadata' in document &&
      document.companyNpwpDocumentMetadata?.companyName &&
      document.companyNpwpDocumentMetadata?.npwpNumber
  );
}
